import globalStyles from "../../assets/styles/global.module.scss";


export default function Required() {

  return (
      <span className={globalStyles.required} >*</span>
  );
}
